/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_BackInputs */

const en_confirm_back = /** @type {(inputs: Confirm_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to lessons`)
};

const he_confirm_back = /** @type {(inputs: Confirm_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לשיעורים`)
};

/**
* | output |
* | --- |
* | "Back to lessons" |
*
* @param {Confirm_BackInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_back = /** @type {((inputs?: Confirm_BackInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_BackInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_back(inputs)
	return he_confirm_back(inputs)
});